import {get} from "../../../../DAL/data-provider";

const ItemsPerPage = 10;

export const searchServer = async (query:  string | null, smartSearchFilter:number, currentPage:number) => {
    return get('/api/sitesearch/search?query=' + query + "&smartSearchFilter=" + smartSearchFilter + "&currentPage=" + currentPage + "&itemsPerPage=" + ItemsPerPage);
};

